
//对象池
export class JdPool{

    private _pool:cc.Node[];

    constructor(private template:cc.Node,private comp?:string){
        this._pool = [];
    }

    recycle(t:cc.Node){
        if (t && this._pool.indexOf(t) == -1) {
            t.removeFromParent(false);//移除不清理
            let cp = this.comp ? t.getComponent(this.comp):null;
            if (cp && cp.unuse) {
                cp.unuse.apply(cp);
            } 
            this._pool.push(t);
        }
    }

    obtain(){
        //获取对象
        let last = this._pool.length - 1;
        if (last<0) {
            return this.instantiate();
            //实例化
        }else{//使用缓存
            let obj = this._pool[last];
            this._pool.length = last;
            let cp = this.comp ? obj.getComponent(this.comp):null;
            if (cp && cp.use) {
                cp.use.apply(cp);
            } 
            return obj;
        }
    }

    private instantiate(){
        let node = cc.instantiate(this.template);
        let cp = this.comp ? node.getComponent(this.comp):null;
        if (cp && cp.use) {
            cp.use.apply(cp);
        } 
        return node;
    }


    clear(){
        let count = this._pool.length;
        for (let i = 0; i < count; i++) {
            let node = this._pool[i];
            node.destroy();
        }
        this._pool.length = 0;
    }


}
